<dashboardnav>
  <div class="reference_body">
    <main class="reference_main">
      <div class="pink_box"></div>
      <div class="green_box"></div>
    <div *ngIf="
    !(isLoadingCountry$ | async) &&
    !(isLoadingState$ | async) &&
    !(isLoadingLga$ | async) &&
    !(isLoadingCommunity$ | async) &&
    !(isLoadingCluster$ | async) &&
    !(isLoadingClusterCommunity$ | async) &&
    !(isLoadingProjectCategory$ | async) &&
    !(isLoadingProjectType$ | async) &&
    !(isLoadingOilBlock$ | async) &&
    !(isLoadingOilField$ | async) &&
    !(isLoadingDocumentCategory$ | async) &&
    !(isLoadingDocumentSubCategory$ | async) &&
    !(isLoadingCurrency$ | async)
    " >

  <div class="container">
  <div class="row">
    <div class="col-sm-3 mt-4 ml-5">
  <mat-form-field class="full-width-field">
      <mat-label>Select Project Reference Form</mat-label>
      <mat-select
      (selectionChange)="selectReference($event)" >
        <mat-option>None</mat-option>
        <mat-option class="option" *ngFor="let item of items" [value]="item.id"
          >{{ item.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <!-- <main id="logout-button-holder">
      <button mat-raised-button id="logout-button" (click)="openLogoutModal()">Logout</button>
      <button mat-raised-button id="delete-product-button" (click)="openDeleteProductModal()">Delete Product</button>
    </main> -->
    </div>
  </div>
  </div>
  </div>
    <div [ngSwitch]="task">
      <ng-template ngSwitchCase="reference">
        <mrsoftapps-project-reference-form-view
          [countries]="country$ | async"
          [states]="state$ | async"
          [lgas]="lga$ | async"
          [clusters]="cluster$ | async"
          [clusterCommunities]="clusterCommunity$ | async"
          [projectCategories]="projectCategory$ | async"
          [projectTypes]="projectType$ | async"
          [communities]="community$ | async"
          [oilBlocks]="oilBlock$ | async"
          [oilFields]="oilField$ | async"
          [documentCategories]="documentCategory$ | async"
          [currencies]="currency$ | async"
          [documentSubCategories]="documentSubCategory$ | async"
          [data]="data"
          (changeEmit)="onSubmitProjectRef($event)"
          (deleteEvent)="onDelete($event)"
          *ngIf="
          !(isLoadingCountry$ | async) &&
          !(isLoadingState$ | async) &&
          !(isLoadingLga$ | async) &&
          !(isLoadingCommunity$ | async) &&
          !(isLoadingCluster$ | async) &&
          !(isLoadingClusterCommunity$ | async) &&
          !(isLoadingProjectCategory$ | async) &&
          !(isLoadingProjectType$ | async) &&
          !(isLoadingOilBlock$ | async) &&
          !(isLoadingOilField$ | async) &&
          !(isLoadingDocumentCategory$ | async) &&
          !(isLoadingDocumentSubCategory$ | async) &&
          !(isLoadingCurrency$ | async)
          "
        >
        </mrsoftapps-project-reference-form-view>
      </ng-template>
    </div>
    <mrsoftapps-epims-reference-spinner *ngIf="
    (isLoadingCountry$ | async) ||
    (isLoadingState$ | async) ||
    (isLoadingLga$ | async) ||
    (isLoadingCommunity$ | async) ||
    (isLoadingCluster$ | async) ||
    (isLoadingClusterCommunity$ | async) ||
    (isLoadingProjectCategory$ | async) ||
    (isLoadingProjectType$ | async) ||
    (isLoadingOilBlock$ | async) ||
    (isLoadingOilField$ | async) ||
    (isLoadingDocumentCategory$ | async) ||
    (isLoadingDocumentSubCategory$ | async) ||
    (isLoadingCurrency$ | async)
    ">
    </mrsoftapps-epims-reference-spinner>
    </main>
    </div>
  </dashboardnav>
